import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FilterByTypePipe } from './components/offices-map/filter-by-type.pipe';
import { OfficesMapComponent } from './components/offices-map/offices-map.component';
import { PostOfficesInfoComponent } from './components/post-offices-info/post-offices-info.component';
import { PointInfoComponent } from './components/post-offices-info/point-info/point-info.component';
import { MapComponent } from '$shared/components/map';

@NgModule({
  declarations: [
    OfficesMapComponent,
    PostOfficesInfoComponent,
    PointInfoComponent,
    FilterByTypePipe,
  ],
  imports: [CommonModule, TranslateModule, MapComponent],
  providers: [FilterByTypePipe],
  exports: [OfficesMapComponent, FilterByTypePipe],
})
export class OfficesMapModule {}
